import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "button"];

  declare readonly formTarget: HTMLElement;
  declare readonly hasFormTarget: boolean;
  declare readonly buttonTarget: HTMLElement;
  declare readonly hasButtonTarget: boolean;

  toggle() {
    if (this.hasFormTarget) {
      this.formTarget.classList.remove("hidden");
      const textarea = this.formTarget.querySelector("textarea");
      if (textarea) textarea.focus();
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add("hidden");
    }
  }

  cancel() {
    if (this.hasFormTarget) {
      this.formTarget.classList.add("hidden");
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.remove("hidden");
    }
  }
}
